// extracted by mini-css-extract-plugin
module.exports = {"trigger":"index_trigger__2M79x","logoContainer":"index_logoContainer__2WryJ","logo":"index_logo__1TGeF","menu":"index_menu__2FZp6"};